/*
 * Hero slideshow — reduced-motion guard.
 *
 * The hero's play/pause control is hidden by orvex-premium.css. Dawn's
 * SlideshowComponent only consults `prefers-reduced-motion` on the branch it
 * takes when that control is absent, so an auto-advancing hero would otherwise
 * keep moving for people who have asked their OS for less motion (WCAG 2.2.2).
 *
 * This pauses the rotation for those visitors and resumes it if they change the
 * preference. Arrows and dots keep working either way, so the slideshow stays
 * fully navigable by hand.
 */
(function () {
  if (!window.matchMedia) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function autoplayingSlideshows() {
    var found = [];
    var nodes = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Only slideshows that arm autoplay via the (now hidden) toggle button.
      // Dawn already handles the buttonless announcement-bar case itself.
      if (!el.querySelector('.slideshow[data-autoplay="true"]')) continue;
      if (!el.querySelector('.slideshow__autoplay')) continue;
      if (typeof el.pause !== 'function' || typeof el.play !== 'function') continue;
      found.push(el);
    }
    return found;
  }

  function apply() {
    var slideshows = autoplayingSlideshows();
    for (var i = 0; i < slideshows.length; i++) {
      var el = slideshows[i];
      if (reduceMotion.matches) {
        // Mirrors a press of the pause button, so focus/hover handlers in
        // global.js will not quietly restart the rotation.
        el.autoplayButtonIsSetToPlay = false;
        el.pause();
      } else if (el.autoplayButtonIsSetToPlay === false) {
        el.autoplayButtonIsSetToPlay = true;
        el.play();
      }
    }
  }

  function init() {
    apply();
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', apply);
    } else if (reduceMotion.addListener) {
      reduceMotion.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
